import { render, staticRenderFns } from "./CorporationInfo.vue?vue&type=template&id=6868be9b&scoped=true&lang=pug&"
import script from "./CorporationInfo.vue?vue&type=script&lang=ts&"
export * from "./CorporationInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CorporationInfo.vue?vue&type=style&index=0&id=6868be9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6868be9b",
  null
  
)

/* custom blocks */
import block0 from "./CorporationInfo.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yml"
if (typeof block0 === 'function') block0(component)
import block1 from "./CorporationInfo.vue?vue&type=custom&index=1&blockType=i18n&locale=ja&lang=yml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoadImage: require('/app/src/components/atoms/LoadImage.vue').default})
